import angular from 'angular';

export const ApuracoesPontoListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider): void {
		const accessResolve = [
            '$rootScope',
            '$state',
            '$q',
            function (
                $rootScope: angular.IRootScopeService & {
                    liberadoTela: (arg: string) => boolean,
                    temPermissao: (arg: string) => boolean,
                },
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (
                    $rootScope.temPermissao('visualizar_apuracoes') &&
                    $rootScope.liberadoTela('LIBERAR_APURACOES_PONTO')
                ) {
                    return true;
                }

                $state.go('dp');
                return $q.reject('Acesso negado ao módulo de apurações de ponto.');
            }
        ];

		$stateProvider
			.state('apuracoesponto', {
				url: '/ponto/apuracoes?q?situacao?estabelecimento',
				template: require('html-loader!./index/apuracoesponto.index.html'),
                resolve: {
                    'access': accessResolve
                },
				controller: 'ApuracoesPontoIndexController',
				controllerAs: 'mrh_aprcspt_lst_cntrllr',
				reloadOnSearch: false
			})
			.state('apuracoesponto_saldo_inicial', {
				url: '/ponto/apuracoes/{apuracao}/saldo-inicial',
				template: require('html-loader!./saldo-inicial/saldo-inicial.html'),
                resolve: {
                    'access': accessResolve
                },
				controller: 'SaldoInicialController',
				controllerAs: 'mrh_aprcspt_sld_ncl_cntrllr',
				reloadOnSearch: false
			});
	}
];
